export default __webpack_public_path__ + "static/media/Alice-Regular.43509965.ttf";